import { useContext } from "react";
import { useSelector } from "react-redux";
import { Preferences } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  preferences: Preferences;
  retrieveUserPreferences(
    request: Boundaries["retrieveUserPreferences"]["request"],
  ): void;
}

function useUserPreferencesRetrieval(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isUserPreferencesRetrievalRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isUserPreferencesRetrievalRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isUserPreferencesRetrievalRequestFailure,
    ),
    preferences: useSelector(selector.getUserPreferences),
    retrieveUserPreferences: core.retrieveUserPreferences,
  };
}

export { useUserPreferencesRetrieval };
